var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueOnGeoAutocomplete',{attrs:{"label":"Kraków Wadowicka 8A","url":_vm.realUrl,"text":"title","value":"title","title":"title","subTitle":"subTitle","wrapper":_vm.wrapItem},on:{"selected":_vm.selected}})}
var staticRenderFns = []

export { render, staticRenderFns }